// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const count_PEOPLE_THINK_IT_IS_USEFUL = ["%(count)s \u010dlovek pova\u017euje za u\u017eito\u010dn\u00e9", "%(count)s \u013eudia pova\u017euj\u00fa za u\u017eito\u010dn\u00e9", "%(count)s \u013eud\u00ed pova\u017euje za u\u017eito\u010dn\u00e9"];
export const DELETE_REVIEW_REPLY = "Zma\u017e odpove\u010f";
export const HOME_RIGHT_MORE_REVIEWS = "\u010eal\u0161ie hodnotenia...";
export const USEFUL = "U\u017eito\u010dn\u00e9";
